import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";

import firebase from "firebase/app";
import { authState } from "rxfire/auth";
import { collectionData } from "rxfire/firestore";
import { filter } from "rxjs/operators";

const firebaseConfig = {
  apiKey: "AIzaSyBurt6eIdgAaJOsXde2OW0J2lcMyGIX9kM",
  authDomain: "heads-up-e05ce.firebaseapp.com",
  databaseURL: "https://heads-up-e05ce.firebaseio.com",
  projectId: "heads-up-e05ce",
  storageBucket: "heads-up-e05ce.appspot.com",
  messagingSenderId: "282040906798",
  appId: "1:282040906798:web:a4f480fc861a7c11ce5bbf",
  measurementId: "G-6C4DSN3634"
};

const app = firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore(app);
const auth = firebase.auth(app);
const storage = firebase.storage();
const functions = firebase.functions();
const loggedIn$ = authState(auth).pipe(filter(user => !!user));
export {
  firebase,
  storage,
  functions,
  app,
  auth,
  firestore,
  collectionData,
  loggedIn$
};

// export default firebase;
